const rankings = [
  { rank: 1, title: '某顶流男星婚内出轨实锤？深夜视频画面全网疯传', hot: 9850, tag: '娱乐圈', change: 'up' },
  { rank: 2, title: '当红女团成员被指霸凌队友，聊天记录截图流出引热议', hot: 9210, tag: '娱乐圈', change: 'up' },
  { rank: 3, title: '某直播平台头部主播涉嫌偷税被调查，金额惊人', hot: 8740, tag: '网红', change: 'up' },
  { rank: 4, title: '某电商平台双11数据造假，商家联名举报函全文曝光', hot: 8290, tag: '电商', change: 'new' },
  { rank: 5, title: '某知名餐饮品牌后厨卫生状况堪忧，内部员工晒实拍图', hot: 7850, tag: '社会', change: 'down' },
  { rank: 6, title: '某上市公司财务报表疑点重重，证监会已介入调查', hot: 7320, tag: '财经', change: 'up' },
  { rank: 7, title: '某短视频平台大V人设崩塌，背后产业链遭深度起底', hot: 6980, tag: '网红', change: 'down' },
];

function getChangeIcon(change: string) {
  switch (change) {
    case 'up': return <i className="ri-arrow-up-line text-green-500"></i>;
    case 'down': return <i className="ri-arrow-down-line text-red-400"></i>;
    case 'new': return <span className="text-[10px] px-1 py-0.5 bg-accent-500 text-background-50 rounded-full">新</span>;
    default: return null;
  }
}

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-accent-600 font-medium bg-accent-50 px-3 py-1 rounded-full">热度排行</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">爆料热度榜</h2>
          <p className="mt-2 text-sm text-foreground-500">实时热度排名，看看今天什么瓜最火</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
            {rankings.map((item, index) => (
              <div
                key={index}
                className={`flex items-center gap-4 p-4 cursor-pointer hover:bg-background-100 transition-colors ${
                  index < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-400 text-background-50' :
                  item.rank === 3 ? 'bg-accent-500 text-background-50' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">{item.tag}</span>
                    {getChangeIcon(item.change)}
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 leading-relaxed line-clamp-1">{item.title}</h3>
                </div>

                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-bold text-primary-600">{item.hot.toLocaleString()}</div>
                  <div className="text-[10px] text-foreground-400">热度值</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}